import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { useEffect } from "react";
import { useAutosaveContext } from "src/components/DocViewer/components/markdownDocViewer/rawEditor/AutoSavePlugin";
import ToolbarPlugin from "./toolbarPlugin/ToolbarPlugin";

const ToolbarContainer = ({
  hideToolbar = false,
}: {
  hideToolbar?: boolean;
}) => {
  const [editor] = useLexicalComposerContext();
  const { isAutosaving } = useAutosaveContext();

  useEffect(() => {
    editor.setEditable(!hideToolbar);
  }, [hideToolbar]);

  return (
    <div
      className={`relative z-[3] bg-gray-50 border-b border-solid border-b-gray-300 border-x-0 border-t-0 w-full rounded-t-md flex justify-between align-center ${hideToolbar ? "hidden" : ""}`}
    >
      <ToolbarPlugin />
      <div className="flex items-center gap-2">
        {isAutosaving && (
          <div className="flex items-center justify-center text-sm mr-2">
            auto-saving...
          </div>
        )}
      </div>
    </div>
  );
};

export default ToolbarContainer;
